import React, { useState, useEffect } from 'react';
import API from '../../services/api';

const SalesInventoryCommision = () => {
    const [sales, setSales] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState(''); // Search state
    const limit = 5;

    const fetchComm = async () => {
        setLoading(true);
        try {
            const res = await API.get('/v1/commision/commission-sales', {
                params: { 
                    page: page, 
                    limit: limit,
                    search: searchTerm // Search term bhej rahe hain
                }
            });
            if (res.data.success) {
                setSales(res.data.data);
                setTotalPages(res.data.totalPages);
            }
        } catch (err) { 
            console.error("Fetch Error:", err.response);
        }
        setLoading(false);
    };

    // Jab page ya search badle to data dobara aaye
    useEffect(() => { 
        fetchComm(); 
    }, [page, searchTerm]);

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div>
                    <h3 style={styles.title}>Commission Ledger</h3>
                    <p style={styles.subTitle}>Agent based sales tracking</p>
                </div>
                <div style={styles.headerActions}>
                    {/* Search Input Working */}
                    <input 
                        type="text" 
                        placeholder="Search Agent/Customer..." 
                        style={styles.searchBar} 
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPage(1); // Search par page 1 par le jayein
                        }}
                    />
                </div>
            </div>

            <div style={styles.card}>
                <div style={styles.scrollWrapper}>
                    <table style={styles.table}>
                        <thead>
                            <tr style={styles.tableHeader}>
                                <th style={styles.th}>Date</th>
                                <th style={styles.th}>Agent Details</th>
                                <th style={styles.th}>Customer</th>
                                <th style={styles.th}>Bike Details</th>
                                <th style={styles.th}>Commission</th>
                                <th style={styles.th}>Method</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" style={styles.loader}>Loading...</td></tr>
                            ) : sales.length > 0 ? sales.map(s => (
                                <tr key={s.id} style={styles.tr}>
                                    <td style={styles.td}>{new Date(s.sale_date).toLocaleDateString('en-GB')}</td>
                                    <td style={styles.td}>
                                        <div style={styles.pText}>{s.agent_name}</div>
                                        <div style={styles.sText}>ID: #{s.agent_id}</div>
                                    </td>
                                    <td style={styles.td}>{s.customer_name}</td>
                                    <td style={styles.td}>
                                        <div style={styles.pText}>{s.model_name}</div>
                                        <div style={styles.sText}>{s.engine_number}</div>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={styles.amt}>Rs {parseInt(s.dealer_commission).toLocaleString()}</span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={styles.badgeGrey}>{s.payment_method || 'Cash'}</span>
                                    </td>
                                </tr>
                            )) : (
                                <tr><td colSpan="6" style={{textAlign:'center', padding:'20px', color:'#94a3b8'}}>No records found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div style={styles.pagination}>
                    <span style={styles.pText}>Page {page} of {totalPages}</span>
                    <div style={styles.btnGroup}>
                        <button disabled={page === 1} onClick={() => setPage(p => p - 1)} style={page === 1 ? styles.disBtn : styles.pgBtn}>Back</button>
                        <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)} style={page === totalPages ? styles.disBtn : styles.pgBtn}>Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: { width: '100%', boxSizing: 'border-box' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', padding: '0 5px' },
    title: { fontSize: '18px', fontWeight: '700', color: '#059669', margin: 0 },
    subTitle: { fontSize: '11px', color: '#94a3b8', margin: 0 },
    headerActions: { display: 'flex', gap: '10px' },
    searchBar: { padding: '8px 15px', borderRadius: '8px', border: '1px solid #cbd5e1', width: '250px', fontSize: '13px', outline: 'none' },
    card: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', width: '100%', overflow: 'hidden' },
    scrollWrapper: { overflowX: 'auto' },
    table: { width: '100%', borderCollapse: 'collapse', minWidth: '800px' },
    tableHeader: { background: '#f8fafc' },
    th: { padding: '14px 15px', textAlign: 'left', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', borderBottom: '1px solid #e2e8f0' },
    tr: { borderBottom: '1px solid #f1f5f9' },
    td: { padding: '12px 15px', fontSize: '13px', verticalAlign: 'middle' },
    pText: { fontWeight: '600', color: '#334155', fontSize: '13px' },
    sText: { fontSize: '11px', color: '#94a3b8' },
    amt: { fontWeight: '700', color: '#059669', fontSize: '14px' },
    badgeGrey: { background: '#f1f5f9', color: '#475569', padding: '4px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: '700' },
    pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', borderTop: '1px solid #f1f5f9' },
    pgBtn: { padding: '6px 15px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
    disBtn: { padding: '6px 15px', borderRadius: '6px', border: '1px solid #f1f5f9', background: '#f8fafc', color: '#cbd5e1', cursor: 'not-allowed', fontSize: '12px' }
};

export default SalesInventoryCommision;